<ion-header>
  <ion-toolbar>
    <ion-title>Request Withdrawal</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="cancel()" aria-label="Close">
        <ion-icon slot="icon-only" name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <p class="balance-line">Available: <strong>${{ availableBalance | number:'1.2-2' }}</strong></p>

  <ion-item>
    <ion-label position="stacked">Amount (USD)</ion-label>
    <ion-input type="number" [(ngModel)]="valor" placeholder="0.00" min="0" inputmode="decimal"></ion-input>
  </ion-item>

  <ion-item>
    <ion-label position="stacked">Receive via</ion-label>
    <ion-select [(ngModel)]="metodoRecebimento" interface="action-sheet">
      <ion-select-option value="Zelle">Zelle</ion-select-option>
      <ion-select-option value="ContaBancaria">Bank Account</ion-select-option>
      <ion-select-option value="ContaInternacional">International Account</ion-select-option>
    </ion-select>
  </ion-item>

  <p class="hint">Make sure your payout method is registered in <em>Payout Methods</em> before submitting.</p>

  <ion-button expand="block" color="primary" (click)="submit()" [disabled]="!isValid() || submitting">
    <ng-container *ngIf="!submitting">Submit Request</ng-container>
    <ng-container *ngIf="submitting">Submitting...</ng-container>
  </ion-button>
</ion-content>
